import { render, staticRenderFns } from "./ExamCard.vue?vue&type=template&id=7f67a933&scoped=true&"
import script from "./ExamCard.vue?vue&type=script&lang=js&"
export * from "./ExamCard.vue?vue&type=script&lang=js&"
import style0 from "./ExamCard.vue?vue&type=style&index=0&id=7f67a933&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f67a933",
  null
  
)

export default component.exports